import React, { Component } from "react";
import { connect } from "react-redux";
import { formInput, clearFormInput } from "actions/FormActions";
import { Autocomplete, TextField } from "@mui/material";

class AutoCompleteInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || "", // Initialize with Redux value or empty
            error: props.error || "",
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        // Sync state with Redux when props change
        const updates = {};
        if (nextProps.value !== prevState.value) {
            updates.value = nextProps.value || "";
        }
        if (nextProps.error !== prevState.error) {
            updates.error = nextProps.error || "";
        }
        return Object.keys(updates).length ? updates : null;
    }

    onSelect = (chosenRequest) => {
        if (chosenRequest) {
            this.updateStore(chosenRequest.value || chosenRequest); // Handle both object and primitive options
        } else {
            this.updateStore("");
        }
    };

    updateInput = (searchText) => {
        if (!searchText) {
            this.props.clearFormInput(this.props.name);
        } else {
            this.props.formInput(searchText, this.props.name);
        }
    };

    updateStore(value) {
        this.props.formInput(value, this.props.name);
    }

    render() {
        const { className, options = [], floatingLabelText, fullWidth } = this.props;
        const { value, error } = this.state;

        return (
            <div className={className || "form-group"}>
                <Autocomplete
                    options={options}
                    openOnFocus={true}
                    getOptionLabel={(option) => (typeof option === "object" ? option.text: option) || ""}
                    filterOptions={(options) => options.slice(0, 30)}
                    fullWidth={fullWidth}
                    value={value || null} // Set the current value
                    onChange={(event, newValue) => this.onSelect(newValue)}
                    onInputChange={(event, newValue) => this.updateInput(newValue)}
                    ListboxProps={{
                        style: { maxHeight: 200, overflow: "auto" },
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="standard"
                            label={floatingLabelText || "Search"}
                            error={Boolean(error)}
                            helperText={error}
                        />
                    )}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    value: state.form[props.name],
    error: state.form && state.form.error && state.form.error[props.name]
});

const mapDispatchToProps = (dispatch) => ({
    formInput: (value, name) => dispatch(formInput(value, name)),
    clearFormInput: (name) => dispatch(clearFormInput(name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoCompleteInput);
